<template>
  <div>
    <b-row>
      <b-col>
        <!-- Main table element -->
        <b-table
          :items="getItemsForTurnTable"
          :fields="fields"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          show-empty
          empty-text="No hay registros para mostrar"
          small
          responsive
          hover
          no-border-collapse
          bordered
          @filtered="onFiltered"
        >
          <template #thead-top>
            <b-tr>
              <b-th colspan="2" variant="danger">(S) Situación</b-th>
              <b-th colspan="6" variant="primary">(B) Información</b-th>
              <b-th colspan="2" variant="info">(A) Evaluación</b-th>
              <b-th colspan="7" variant="secondary">(R) Recomendaciones</b-th>
            </b-tr>
          </template>

          <template #cell(PatAdmDate)="row">
            {{ $dateFormat(row.value, "dd-mm-yy") }}
          </template>

          <template #cell(dateCurrent)="row">
            <!-- {{ $dateFormat(row.value, "dd-mm-yy") }} -->
            {{ formatDateCurrent(row.value) }}
          </template>

          <template #cell(diagnosis)="row">
            <!-- {{ cutDiagnosisText(row.value) }} -->
            <b-button pill :id="`popover-${row.value}`" variant="primary">
              <b-icon-journal-arrow-up></b-icon-journal-arrow-up>
            </b-button>
            <b-popover
              :target="`popover-${row.value}`"
              title="Tratamiento"
              triggers="hover focus"
            >
              {{ cutDiagnosisText(row.value) }}
            </b-popover>
            <!-- {{ row.value }} -->
          </template>

          <template #cell(treatment)="row">
            <b-button pill :id="`popover-${row.value}`" variant="info">
              <b-icon-eye></b-icon-eye>
            </b-button>
            <b-popover
              :target="`popover-${row.value}`"
              title="Tratamiento"
              triggers="hover focus"
            >
              {{ cleanString(row.value) }}
            </b-popover>
          </template>

          <template #cell(risks)="row">
            <ul class="list-unstyled">
              <li v-for="(item, index) in row.value" :key="index">
                {{
                  item.name === "label" ||
                  item.name === "name" ||
                  item.name === "value"
                    ? ""
                    : `${index + 1}.`
                }}
                {{
                  item.name === "label" ||
                  item.name === "name" ||
                  item.name === "value"
                    ? ""
                    : item.label
                }}
              </li>
            </ul>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "turnDoctorDelivery",
  props: {
    data: Array,
  },
  data() {
    return {
      fields: [
        {
          key: "PatHabitation",
          label: "HAB",
          sortable: true,
          sortDirection: "desc",
          class: "text-center align-middle",
        },
        {
          key: "nameComplete",
          label: "Nombres y Apellidos",
          sortable: true,
          sortDirection: "desc",
          class: "text-center align-middle",
        },
        {
          key: "PatDoc",
          label: "Documento",
          sortable: true,
          sortDirection: "desc",
          class: "text-center align-middle",
        },
        {
          key: "PatAge",
          label: "Edad",
          sortable: true,
          sortDirection: "desc",
          class: "text-center align-middle",
        },
        {
          key: "PatAdmDate",
          label: "Ingreso (d-m-a)",
          sortable: true,
          sortDirection: "desc",
          class: "text-center align-middle",
        },
        {
          key: "PatCompany",
          label: "Contrato",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "diagnosis",
          label: "Diagnósticos",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "COMedicalspecialist",
          label: "Especialidad Tratante",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "treatment",
          label: "Tratamiento",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "risks",
          label: "Riesgos",
          sortable: true,
          class: "text-center",
        },
        {
          key: "pendientes",
          label: "Pendientes y Recomendaciones",
          sortable: true,
          class: "text-center",
        },
        {
          key: "dateCurrent",
          label: "Fecha Entrega (d-m-a)",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "hourCurrent",
          label: "Hora Entrega",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "doctorWhoDelivers",
          label: "Medico Entrega",
          sortable: true,
          class: "text-center",
          variant: "success",
        },
        {
          key: "doctorReceives",
          label: "Medico Recibe",
          sortable: true,
          class: "text-center",
          variant: "success",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      charac: "&#x0D;",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getItemsForTurnTable() {
      return this.data;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    cleanString(input) {
      return input.replaceAll("&#x0D;", "\n");
    },
    cutDiagnosisText(input) {
      const cleanInput = input.replaceAll("&#x0D;", "\n");
      const myArray = cleanInput
        .split("\n==DIAGNOSTICOS==")
        .pop()
        .split("REFIERE");
      const result = myArray[0];
      return result;
    },
    formatDateCurrent(input) {
      const result = moment(input).format("DD-MM-Y");
      return result;
    },
  },
};
</script>

<style>
table td:nth-child(6),
table td:nth-child(7),
table td:nth-child(8) {
  width: 200px;
}
table td:nth-child(10) {
  width: 250px !important;
}
table td:nth-child(11) {
  width: 350px;
}
</style>
